import http, { Http } from '@/lib/http';

interface Params {
  projectId: string;
}

function gtmDisconnectCtor(http: Http) {
  return async ({ projectId }: Params): Promise<any> => {
    const { data } = await http.post(`/projects/${projectId}/integrations/gtm/disconnect`);
    return data;
  };
}

export const gtmDisconnect = gtmDisconnectCtor(http);
